import React, {useEffect} from 'react';
import {NavLink} from "react-router-dom";

const NotFound = () => {
  useEffect(()=> {
    if (document.getElementById('mobile-menu').classList.contains("flex")) {
      document.getElementById('mobile-menu').classList.replace("flex", "hidden");
    }
  }, [])

  return (
    <div className="flex flex-col justify-center items-center h-screen w-full">
      <h3 className="text-9xl text-red-600">404</h3>
      <p className="text-4xl uppercase">page not found</p>
      <NavLink exact to="/">
        <p className="text-2xl capitalize underline text-blue-400 hover:text-gray-500">go home</p>
      </NavLink>
    </div>
  );
};

export default NotFound;
